import { c as _c } from "react/compiler-runtime";
import MediaTypeBadge from "@/components/drops/media/MediaTypeBadge";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { removeBaseEndpoint } from "@/helpers/Helpers";
import { useDrop } from "@/hooks/useDrop";
import Link from "next/link";
import ChatItemHrefButtons from "../ChatItemHrefButtons";
import { SingleWaveDropPosition } from "../drop/SingleWaveDropPosition";
import { SingleWaveDropVotes } from "../drop/SingleWaveDropVotes";
export default function DropItemChat(t0) {
  const $ = _c(43);
  const {
    href,
    dropId
  } = t0;
  const {
    isMemesSubmission
  } = useSeizeSettings();
  let t1;
  if ($[0] !== dropId) {
    t1 = {
      dropId
    };
    $[0] = dropId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    drop
  } = useDrop(t1);
  let t2;
  if ($[2] !== href) {
    t2 = removeBaseEndpoint(href);
    $[2] = href;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const relativeLink = t2;
  let t3;
  if ($[4] !== drop?.parts) {
    t3 = drop?.parts?.at(0)?.media?.at(0);
    $[4] = drop?.parts;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const artworkMedia = t3;
  let t4;
  if ($[6] !== drop?.metadata || $[7] !== drop?.title) {
    t4 = drop?.metadata?.find(_temp)?.data_value || drop?.title;
    $[6] = drop?.metadata;
    $[7] = drop?.title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const title = t4;
  if (!drop) {
    let t5;
    if ($[9] !== href || $[10] !== relativeLink) {
      t5 = <Link href={relativeLink}>{href}</Link>;
      $[9] = href;
      $[10] = relativeLink;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t5;
  if ($[12] !== artworkMedia?.mime_type || $[13] !== drop || $[14] !== isMemesSubmission) {
    t5 = isMemesSubmission(drop) && <MediaTypeBadge mimeType={artworkMedia?.mime_type} dropId={drop.id} size="sm" />;
    $[12] = artworkMedia?.mime_type;
    $[13] = drop;
    $[14] = isMemesSubmission;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== relativeLink || $[17] !== title) {
    t6 = <h3 className="tw-mb-0 tw-text-base tw-font-semibold tw-text-iron-100 sm:tw-text-lg"><Link className="tw-no-underline" href={relativeLink}>{title}</Link></h3>;
    $[16] = relativeLink;
    $[17] = title;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-x-2">{t5}{t6}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== drop) {
    t8 = drop?.drop_type === ApiDropType.Participatory && <SingleWaveDropPosition rank={drop.rank} />;
    $[22] = drop;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t7 || $[25] !== t8) {
    t9 = <div className="tw-flex tw-flex-row tw-items-center tw-gap-x-4">{t7}{t8}</div>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== drop || $[28] !== relativeLink) {
    t10 = drop && <><span className="tw-leading-0 -tw-mt-1 tw-mb-0 tw-text-[11px] tw-text-iron-500 tw-no-underline tw-transition tw-duration-300 tw-ease-out"><Link className="tw-no-underline" href={relativeLink}>{drop.wave.name}</Link></span><SingleWaveDropVotes drop={drop} /></>;
    $[27] = drop;
    $[28] = relativeLink;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== artworkMedia || $[31] !== drop) {
    t11 = artworkMedia && <div className="tw-mt-4 tw-flex tw-h-96 tw-justify-center"><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={drop.drop_type === ApiDropType.Participatory || drop.drop_type === ApiDropType.Winner} /></div>;
    $[30] = artworkMedia;
    $[31] = drop;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t9) {
    t12 = <div className="tw-min-w-0 tw-flex-1"><div className="tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-p-4">{t9}{t10}{t11}</div></div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t9;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== href || $[38] !== relativeLink) {
    t13 = <ChatItemHrefButtons href={href} relativeHref={relativeLink} />;
    $[37] = href;
    $[38] = relativeLink;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== t12 || $[41] !== t13) {
    t14 = <div className="tw-flex tw-w-full tw-items-stretch tw-gap-x-1">{t12}{t13}</div>;
    $[40] = t12;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  return t14;
}
function _temp(m) {
  return m.data_key === "title";
}